import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC } from "react";
// import { connect } from "react-redux"; // Poolcorp Custom Code

/* Poolcorp Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useIsFilterNavOpen from "@store/Pages/ProductList/Hooks/useIsFilterNavOpen";
import setIsFilterNavOpen from "@store/Store/Pages/ProductList/Handlers/SetIsFilterNavOpen";
import { gridGapStyles } from "@store/theme/common/mixins";
import { baseGridProps } from "@store/theme/common/props/baseGrid";
import { mobileFiltersModalProps } from "@store/theme/common/props/mobileFiltersModal";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const SortSelect = getWidgetComponent("ProductList/ProductListSortSelect");

const mapDispatchToProps = {
    setIsFilterNavOpen,
    clearAllProductFilters,
};
/* Poolcorp Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Poolcorp Custom Code

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    // Poolcorp Custom Code
    filtersModal?: ModalPresentationProps;
    modalTitleWrapper?: InjectableCss;
    modalTitle?: TypographyPresentationProps;
    buttonsWrapper?: InjectableCss;
    applyFiltersButton?: ButtonPresentationProps;
    clearAllFiltersButton?: ButtonPresentationProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        ...baseGridProps.container,
        css: css`
            ${baseGridProps.container?.css}
            ${gridGapStyles(["30px"], ["50px", null, null, "30px"])}
        `,
    },
    leftColumnGridItem: {
        ...baseGridProps.sideColumn,
        css: css`
            ${baseGridProps.sideColumn?.css}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: ["none", null, "block"], properties: ["display"] }],
                    mediaOptions.min,
                )}
        `,
    },
    rightColumnGridItem: baseGridProps.mainColumn,
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
    filtersModal: mobileFiltersModalProps.modal,
    modalTitleWrapper: mobileFiltersModalProps.modalTitleWrapper,
    modalTitle: mobileFiltersModalProps.modalTitle,
    buttonsWrapper: mobileFiltersModalProps.buttonsWrapper,
    applyFiltersButton: mobileFiltersModalProps.primaryButton,
    clearAllFiltersButton: mobileFiltersModalProps.secondaryButton,
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({
    id,
    view,
    // Poolcorp Custom Code
    setIsFilterNavOpen,
    clearAllProductFilters,
}) => {
    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle =
        view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;
    
    
    /* Poolcorp Custom Code */
    const isFilterNavOpen = useIsFilterNavOpen();
    const closeModal = () => {
        setIsFilterNavOpen({ isOpen: false });
        setTimeout(() => setIsFilterNavOpen({ isOpen: undefined }), 300);
    };
    /* Poolcorp Custom Code */
    
    return (
        <GridContainer {...styles.container}>
            <GridItem {...leftColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            {/* Poolcorp Custom Code */}
            <Hidden above="sm">
                <Modal
                    isOpen={isFilterNavOpen}
                    handleClose={closeModal}
                    {...styles.filtersModal}
                >
                    <StyledWrapper {...styles.modalTitleWrapper}>
                        <Typography {...styles.modalTitle} data-test-selector="productListFilterList">
                            {translate("Sort & Filter")}
                        </Typography>
                    </StyledWrapper>
                    <SortSelect fields={{}} labelPosition="top" />
                    <Zone contentId={id} zoneName="Content00" />
                    <StyledWrapper {...styles.buttonsWrapper}>
                        <Button onClick={closeModal} {...styles.applyFiltersButton}>
                            {translate("Apply")}
                        </Button>
                        <Button onClick={() => clearAllProductFilters()} {...styles.clearAllFiltersButton}>
                            {translate("Clear Filters")}
                        </Button>
                    </StyledWrapper>
                </Modal>
            </Hidden>
            {/* Poolcorp Custom Code */}
            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
